<template>
    <b-modal size="xl" button-size="sm" @hidden="close" @close="close" hide-footer v-model="showModal"
        :title="prefix + title">

        <AlmoxarifadoList :departamento="departamento" @onDblClickAlmoxarifado="almoxarifadoSelect">
        </AlmoxarifadoList>
    </b-modal>
</template>
<script>

export default {
    components: { AlmoxarifadoList: () => import("@/modules/almoxarifados/almoxarifado/AlmoxarifadoList.vue") },

    props: {
        id: String,
        prefix: {
            type: String,
            default: "",
        },
        departamento: Object,

    },
    data() {
        return {
            showModal: true,
            title: "Almoxarifado",
        }
    },

    methods: {
        async show() {
            this.showModal = true;
        },

        async almoxarifadoSelect(item) {
            this.$emit("onSelect", item);
        },

        async close() {
            this.$emit("close");
        },
    }

};
</script>